import React, { useState } from 'react'

import * as FaIcons from 'react-icons/fa'
import { Link } from 'react-router-dom';

import { useGlobalState } from '../js/Main'
import { toggleMenu, alertPopup } from './Home';

import logo from '../images/crodudes_logo_1.png'

import { CroCoDudeContractABI, CroCoDudeContract } from '../js/contracts'

import Web3 from 'web3'
import WalletConnectProvider from '@walletconnect/web3-provider'

/* ------------------------- Created By Alhaji (C.CODES)
                             IG: c.codes_ig
                               Twitter: CCODES_web----------------------------------------- */


const Dashboard = () => {
    const nfts = useGlobalState('nfts')[0];
    const account = useGlobalState('connectedAccount')[0];
    const reflection = useGlobalState('reflection')[0];
    const mode = useGlobalState('mode')[0];
    var [pop, setpop] = useState(null);
    const popUp = (id) => {
        pop = nfts.filter((nft) => {
            return id === nft.edition;
        });
        setpop(pop);
        document.querySelector(".minted-popup").style.transform = "scaleY(1)";
    }
    const popOut = () => {
        document.querySelector(".minted-popup").style.transform = "scaleY(0)";
    }
    const mynfts = [];
    if (account) {
        nfts.map((item) => {
            if (item.owner.toUpperCase() === account.toUpperCase()) {
                mynfts.push(item);
            }
        })
    } else {
        alertPopup("Connect Your Wallet", "red", 1500);
    }
    const claimReward = async () => {
        document.querySelector(".collect-reflection-notice").textContent = "Pending..";
        var web3;
        if (mode === 1) {
            web3 = new Web3(window.ethereum);
        } else if (mode === 2) {
            var provider = new WalletConnectProvider({
                rpc: {
                    97: "https://data-seed-prebsc-1-s1.binance.org:8545",
                }
            });
            await provider.enable();
            web3 = new Web3(provider);
        }
        const contract = new web3.eth.Contract(CroCoDudeContractABI, CroCoDudeContract);
        try {
            document.querySelector(".collect-reflection-notice").textContent = "Processing";
            setTimeout(() => {
                document.querySelector(".collect-reflection-notice").textContent = "";
            }, 10000)
            await contract.methods.claimRewards().send({ from: account })
            document.querySelector(".collect-reflection-notice").textContent = "Success";
            alertPopup("Reflection Collected", "green", 3500);
            setTimeout(() => {
                document.querySelector(".collect-reflection-notice").textContent = "";
            }, 5000)
        } catch {
            document.querySelector(".collect-reflection-notice").textContent = "Error";
            alertPopup("Unable to collect reflection", "red", 3000);
            setTimeout(() => {
                document.querySelector(".collect-reflection-notice").textContent = "";
            }, 4000)
        }
    }
    return (
        <>
            <header className="row">
                <div className="row logo">
                    <div className="logo-box">
                        <img src={logo} alt="" />
                    </div>
                    <div>
                        CroCodudes
                    </div>
                </div>
                <div className="toggle" onClick={toggleMenu}>

                </div>
                <div className="sidebar row">
                    <ul className="row">
                        <li onClick={toggleMenu}><Link to="/">Home</Link></li>
                        <li onClick={toggleMenu}><Link to="/minted">Minted</Link></li>
                        <li onClick={toggleMenu} style={{ color: '86A656' }}><Link to="/dashboard">Dashboard</Link></li>
                        <li onClick={toggleMenu}><Link to="/about">About us</Link></li>
                        <li><FaIcons.FaWallet /></li>
                    </ul>
                </div>
            </header>


            <div className=' row minted-popup'>
                <div className='column c-w-wrapper'>
                    <div style={{ color: 'red', textAlign: 'right', fontSize: '30px', cursor: 'pointer' }} onClick={popOut}>
                        <FaIcons.FaTimes />
                    </div>
                    <div className='column nft-data'>
                        {pop ? pop.map((data) => (
                            <div className='row nft-main-info'>
                                <div className='nft-img'>
                                    <img src={data.image} alt="" />
                                </div>
                                <div className='column nft-right'>
                                    <div className='column nft-texts'>
                                        <h2>{data.name}</h2>
                                        <p>{data.description}</p>
                                        <div>Edition: {data.edition}</div>
                                        <div>Reflection: {data.reflection < 1 ? parseFloat(data.reflection).toFixed(6) : parseInt(data.reflection).toLocaleString()} CRO</div>
                                    </div>
                                    <div className='nft-data-foot'>
                                        <h3>Attributes</h3>
                                        <div className='nft-attributes row'>
                                            {data.attributes.map((attr) => (
                                                <div key={attr.value}>
                                                    {attr.trait_type} <span>:</span> {attr.value}
                                                </div>
                                            ))}

                                        </div>
                                    </div>
                                </div>
                            </div>
                        )) : () => { }}
                    </div>
                </div>
            </div>

            <div className='customPopup'>
                <div className='popupData'>
                    
                </div>
            </div>













            <main className='column about-sec dashboard-sec'>
            <h1>Dashboard</h1>
                {account ?
                    <div className='column reflection-sec'>
                        <div className='column reflection-boxes'>
                            <div className='reflection-title'>Accumulative Reflections Earned</div>
                            <div>{reflection < 1 ? parseFloat(reflection).toFixed(5) : parseInt(reflection).toLocaleString()} CRO</div>
                        </div>
                        <div className='column reflection-boxes'>
                            <div className='reflection-title'>Reflections to Collect</div>
                            <div>{reflection < 1 ? parseFloat(reflection).toFixed(5) : parseInt(reflection).toLocaleString()} CRO</div>
                        </div>
                        <div style={{ color: 'red', fontSize: '12px', padding: '20px' }} className='collect-reflection-notice'></div>
                        <button onClick={claimReward}>Collect Reflections</button>
                    </div>
                    : () => { }}

                {nfts.length == 0 ?
                    <div className='spinner'>
                        <div></div>
                    </div>
                    : () => { }
                }
                <div className="row boxes">
                    {account ? mynfts.length != 0 ? mynfts.map((nft) => (
                        <div className="column box" key={nft.edition} onClick={() => popUp(nft.edition)}>
                            <div>{nft.name}</div>
                            <div className="box-img">
                                <img src={nft.image} alt="" />
                            </div>
                            <div className="row mini-reflection">
                                {nft.reflection < 1 ? parseFloat(nft.reflection).toFixed(6) : parseInt(nft.reflection).toLocaleString()} CRO
                            </div>
                        </div>
                    )) : <div style={{ color: 'red', fontSize: '12px', padding: '20px', marginBottom: '200px' }}>Empty Wallet</div> : <div style={{ color: 'red', fontSize: '12px', padding: '20px', marginBottom: '200px' }}>Connect your Wallet<span style={{ color: 'blue', fontWeight: '800' }}><Link to='/'> Here</Link></span> </div>}
                </div>
            </main>
            <footer className='row dash-footer'>
                <div className='main-color-text'>
                    Copyright &copy;2022.CroCoDudes. All Rights Reserved
                </div>
                <div className='row'>
                    <div>Terms & Conditions</div>
                    <div>Privacy Policy</div>
                </div>
            </footer>
        </>
    )
}

export default Dashboard
/* ------------------------- Created By Alhaji (C.CODES)
                             IG: c.codes_ig
                               Twitter: CCODES_web----------------------------------------- */
